import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@kizen/kds/Icon';
import { Typography } from '@kizen/kds/Typography';
import { StatusText } from 'ts-components/PiChat/styles';
import { versionQaIds } from './qaIds';

export type VersionStatusProps = {
  qaPrefix: string;
  isRestoring: boolean;
  reconnecting: boolean;
  isLoading: boolean;
  position: { current: number; total: number } | null;
};

const Pending: FC<{ qaId?: string; text: string }> = ({ qaId, text }) => (
  <StatusText data-qa-id={qaId}>
    <Icon icon="action-loading" size="sm" color="font-placeholder" />
    <Typography size="sm" color="font-placeholder">
      {text}
    </Typography>
  </StatusText>
);

export const VersionStatus: FC<VersionStatusProps> = ({
  qaPrefix,
  isRestoring,
  reconnecting,
  isLoading,
  position,
}) => {
  const { t } = useTranslation();
  const qa = versionQaIds(qaPrefix);
  if (isRestoring) {
    return <Pending qaId={qa.restoring} text={t('Restoring…')} />;
  }
  if (reconnecting) {
    return <Pending qaId={qa.reconnecting} text={t('Reconnecting…')} />;
  }
  if (isLoading) return <Pending text={t('Connecting…')} />;
  if (!position) return null;
  return (
    <StatusText data-qa-id={qa.version}>
      <Typography size="sm" color="font-placeholder">
        {t('Version {{current}} of {{total}}', position)}
      </Typography>
    </StatusText>
  );
};
